import React from 'react';
import './style.scss';
import MetaInfo from './MetaInfo/MetaInfo';
import imgHero from './i/lettuce_hero.jpg';
import imgHeroMobile from './i/mobile/lettuce_hero.jpg';
import arrow from '../../../../assets/images/hero-arrow.png';
import { TranslatableText } from '../../../../providers/LanguageProvider';
import SliderWrap from '../../../../components/SliderWrap/SliderWrap';
import slide1 from './i/carousel_lettuce_1.jpg';
import slide2 from './i/carousel_lettuce_2.jpg';
import slide3 from './i/carousel_lettuce_3.jpg';
import slide4 from './i/carousel_lettuce_4.jpg';
import slide5 from './i/carousel_lettuce_5.jpg';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const Lettuce = (props) => {

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food-pages lettuce">

                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="lettuce" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="lettuce" />
                    }
                </div>

                <div className="copy-block">
                    <h1><span><span className="line"></span><TranslatableText dictionary={{ "en": "Our", "fr": "Notre"}} ></TranslatableText><span className="line"></span></span><TranslatableText dictionary={{ "en": "Lettuce", "fr": "laitue"}} ></TranslatableText></h1>

                    {props.lang === 'en' && <p>We source fresh iceberg lettuce from farmers who know lettuce best, like our partners at Church Brothers Farms. They prioritize taking care of their soil because great soil means great lettuce. And if you ever want to skip the bun or are craving a lil’ extra crunch, ask us to wrap your burger in lettuce.</p>}
                    {props.lang === 'fr' && <p>Notre laitue iceberg provient de fermiers qui s’y connaissent vraiment, comme nos partenaires de Church Brother Farms. Prendre soin du sol est leur priorité, parce qu’ils savent que c’est la base pour obtenir de la laitue de qualité. Et quand vous voulez manger une salade, mais avez aussi envie d’un burger, remplacez gratuitement votre pain par un wrap de laitue croquante.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

            <div className="where-block">
                            
                { props.lang !== 'fr' ?
                    <>
                        <h2>What's our&nbsp;  
                            <span>Lettuce story?</span>
                        </h2>
                    </>
                    :
                    <>
                        <h2>D’où vient notre&nbsp;  
                            <span>laitue?</span>
                        </h2>
                    </>
                }
            </div>

            <SliderWrap {...props}>
                <div key="1" className="item">
                    <div className="itemcol">
                        <img src={slide1} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>RICH SOIL</h3>
                                        <p>Great lettuce requires healthy soil full of nutrients and organic matter.</p>
                                    </>
                                :
                                    <>
                                        <h3>UNE TERRE RICHE</h3>
                                        <p>Une bonne laitue a besoin d’un sol en santé, rempli de nutriments et de matières organiques.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="2" className="item">
                    <div className="itemcol">
                        <img src={slide2} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>FLOWER POWER</h3>
                                        <p>Our growers plant wildflowers as a natural defence against pests.</p>
                                    </>
                                :
                                    <>
                                        <h3>LE POUVOIR DES FLEURS</h3>
                                        <p>Nos producteurs sèment des fleurs sauvages comme moyen naturel d’éloigner les insectes nuisibles.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="3" className="item">
                    <div className="itemcol">
                        <img src={slide3} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>PESTICIDE REDUCTION</h3>
                                        <p>The wildflowers attract beneficial insects reducing the need for pesticides.</p>
                                    </>
                                :
                                    <>
                                        <h3>RÉDUCTION DES PESTICIDES</h3>
                                        <p>Les fleurs attirent les insectes utiles, réduisant l’utilisation de pesticides.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="4" className="item">
                    <div className="itemcol">
                        <img src={slide4} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>WATERED WITH CARE</h3>
                                        <p>Drip irrigation ensures each plant receives the right amount of water.</p>
                                    </>
                                :
                                    <>
                                        <h3>ARROSÉES SOIGNEUSEMENT</h3>
                                        <p>L’irrigation goutte-à-goutte assure que chaque plant reçoit la bonne quantité d’eau, pas plus.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="5" className="item">
                    <div className="itemcol">
                        <img src={slide5} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>NO WASTE</h3>
                                        <p>After the harvest, outer wrapper leaves are tilled into the soil to serve as fertilizer.</p>
                                    </>
                                :
                                    <>
                                        <h3>ZÉRO DÉCHET</h3>
                                        <p>Après la récolte des laitues, les feuilles extérieures sont retirées et réutilisées pour nourrir la terre.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </SliderWrap>

            <IngredientsSlider currentPage="lettuce" {...props} />
            <MobileOrderBanner {...props} />

        </>

    )
}
export default Lettuce;